import { __assign } from "tslib";
import { alpha } from '@mui/system';
export var CheckboxTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var ownerState = _a.ownerState, theme = _a.theme;
            return (__assign(__assign({ position: "relative", padding: theme.spacing(1), color: "currentColor" }, (ownerState.color === 'default' && {
                '&:hover': {
                    backgroundColor: "color-mix(in srgb, currentColor 8%, transparent)",
                },
            })), { '&.Mui-disabled': {
                    '&.Mui-checked': {
                        '&:after': {
                            transform: "rotate(45deg) scale(1)",
                        },
                    },
                }, '&.Mui-checked': {
                    '&:after': {
                        transform: "rotate(45deg) scale(1)",
                    },
                }, '&:before': __assign(__assign(__assign({ content: '""', display: "inline-block", width: 16, height: 16, borderWidth: 2, borderStyle: "solid", boxSizing: "border-box", borderRadius: "2px", borderColor: alpha(theme.palette.common.white, 0.6) }, (ownerState.disabled && {
                    borderColor: alpha(theme.palette.greySecondary.light, 0.16),
                })), (ownerState.color &&
                    ownerState.color !== "default" && __assign({ borderColor: theme.palette[ownerState.color].light, backgroundColor: theme.palette.common.white }, (ownerState.disabled && {
                    borderColor: alpha(theme.palette[ownerState.color].main, 0.16),
                })))), (ownerState.color === 'default' && __assign({ borderColor: "color-mix(in srgb, currentColor 60%, transparent)", backgroundColor: "inherit" }, (ownerState.disabled && {
                    borderColor: "color-mix(in srgb, currentColor 16%, transparent)",
                })))), '&:after': __assign(__assign(__assign(__assign({ content: '""', position: "absolute", display: "inline-block", width: 4, height: 6, transform: "rotate(45deg) scale(0)", marginTop: "-2px", borderBottomWidth: "2px", borderRightWidth: "2px", borderBottomStyle: "solid", borderRightStyle: "solid", transition: "transform .2s linear" }, (ownerState.checked && {
                    transform: "rotate(45deg) scale(1)",
                })), (ownerState.disabled && {
                    borderColor: alpha(theme.palette.common.white, 0.48),
                })), (ownerState.color &&
                    ownerState.color !== "default" && __assign({ borderColor: theme.palette[ownerState.color].main }, (ownerState.disabled && {
                    borderColor: alpha(theme.palette[ownerState.color].main, 0.48),
                })))), (ownerState.color === 'default' && __assign({ borderColor: "inherit" }, (ownerState.disabled && {
                    borderColor: alpha(theme.palette.common.white, 0.48),
                })))), '&.MuiCheckbox-indeterminate': {
                    '&:after': {
                        height: "0",
                        width: 6,
                        marginTop: "0px",
                        transform: "rotate(0) scale(1)",
                    },
                }, svg: {
                    display: "none",
                } }));
        },
    },
}); };
export default CheckboxTheme;
//# sourceMappingURL=theme.js.map